export const index = '/';
export const connect = '/connect/:network';
export const confirmSignup = '/confirm-signup';
export const forgotPassword = '/forgot-password';
export const forgotPasswordSubmit = '/forgot-password-submit';
export const invitation = '/invitation';
export const unsubscribe = '/unsubscribe';
export const login = '/login';
export const passwordLogin = '/password-login';
export const signUp = '/sign-up';
export const logout = '/logout';
export const sso = '/sso';
export const tokenLogin = '/token-login';
export const socialMediaPolicy = '/social-media-policy';
export const authError = '/auth-error';

export const group = '/group/:group_id';
export const groupCreate = '/group/create';
export const groupEdit = '/group/:group_id/edit';
export const groupMembers = '/group/:group_id/members';
export const groupScheduled = '/group/:group_id/scheduled';
export const groupApproval = '/group/:group_id/approval';
export const groupRemoved = '/group/:group_id/removed';
export const groups = '/groups';
export const groupsDepartment = '/groups/department/:department_id';
export const groupsLocation = '/groups/location/:location_id';
export const groupsIOwn = '/groups/owner';
export const groupsModerating = '/groups/moderating';
export const groupsFollowing = '/groups/following';
export const groupsAll = '/groups/all';

export const people = '/people';
export const peopleFollowing = '/people/following';
export const peopleEveryone = '/people/everyone';
export const peopleDepartment = '/people/department/:department_id';
export const peopleLocation = '/people/location/:location_id';
export const profile = '/profile/:profile_id';
export const profileGroups = '/profile/:profile_id/groups';
export const profileFollowing = '/profile/:profile_id/following';
export const profileFollowers = '/profile/:profile_id/followers';

export const activity = '/activity';

export const leaderboard = '/leaderboard';
export const leaderboardView = '/leaderboard/:leaderboard_id';

export const help = 'https://help.everyonesocial.app';

export const adminPeople = '/admin/people';
export const adminPeopleInvite = '/admin/people/invite';
export const adminGroups = '/admin/groups';
export const adminInvitations = '/admin/invitations';
export const adminMessages = '/admin/messages';
export const adminLeaderboards = '/admin/leaderboards';
export const adminContentEmails = '/admin/emails';
export const adminContentEmailCreate = '/admin/emails/create';
export const adminContentEmailEdit = '/admin/emails/:email_id';

export const adminAnalytics = '/admin/analytics';
export const adminAnalyticsOverview = '/admin/analytics/overview';
export const adminAnalyticsGroups = '/admin/analytics/groups';
export const adminAnalyticsUsers = '/admin/analytics/users';
export const adminAnalyticsPosts = '/admin/analytics/posts';
export const adminAnalyticsShares = '/admin/analytics/shares';
export const adminAnalyticsLeaderboards = '/admin/analytics/leaderboards';

export const adminPostManagement = '/admin/post-management';
export const adminUserManagement = '/admin/user-management';

export const adminSettings = '/admin/settings';
export const adminSettingsAccount = '/admin/settings/account';
export const adminSettingsLocations = '/admin/settings/locations';
export const adminSettingsDisclosures = '/admin/settings/disclosures';
export const adminSettingsPolicies = '/admin/settings/policies';
export const adminSettingsReferrals = '/admin/settings/referrals';

export const adminSettingsCompanyOnboarding = '/admin/settings/company-onboarding';
export const adminSettingsCustomOnboarding = '/admin/settings/custom-onboarding';
export const adminSettingsUserSegments = '/admin/settings/user-segments';
export const adminSettingsShareTracking = '/admin/settings/share-tracking';
export const adminSettingsSharing = '/admin/settings/sharing';
export const adminSettingsStickers = '/admin/settings/stickers';
export const adminSettingsAssignments = '/admin/settings/assignments';
export const adminSettingsAssignmentsCreate = '/admin/settings/assignments/create';
export const adminSettingsAssignmentsEdit = '/admin/settings/assignments/:assignment_id';

export const adminUpgrade = '/admin/upgrade';
export const adminBilling = '/admin/billing';

export const account = '/account';
export const connectionSuccess = '/connections/success';
export const connectionFailure = '/connections/failure';
export const content = '/content/:content_id';
export const contentComment = '/content/:content_id/comment';
export const contentLike = '/content/:content_id/like';
export const contentShare = '/content/:content_id/share';
export const discussions = '/discussions';
export const onboarding = '/onboarding';
export const onboardingProfile = '/onboarding/profile';
export const onboardingFollows = '/onboarding/follows';
export const onboardingCreate = '/onboarding/create';
export const onboardingIdentity = '/onboarding/identity';
export const onboardingSocials = '/onboarding/socials';

export const setupProfile = '/setup/profile';
export const setupWorkspace = '/setup/workspace';
export const setupWorkspaceGroups = '/setup/workspace-groups';
export const setupWorkspaceInvites = '/setup/workspace-invites';

export const notifications = '/notifications';
export const search = '/search';

export const postCreate = '/post/create';
export const postEdit = '/post/edit/:content_id';
export const share = '/share';

export const workspaces = '/workspaces';
export const clientCreate = '/client/create';

export const clientSuccess = '/client-success';

export const HOME_TAB_ROUTES = [index, postCreate, postEdit, share];

export const DISCUSSIONS_TAB_ROUTES = [discussions];

export const GROUPS_TAB_ROUTES = [
  group,
  groupCreate,
  groupEdit,
  groupsDepartment,
  groupsLocation,
  groupMembers,
  groupApproval,
  groupScheduled,
  groupRemoved,
  groups,
  groupsModerating,
  groupsFollowing,
  groupsAll,
];

export const PEOPLE_TAB_ROUTES = [
  people,
  peopleFollowing,
  peopleEveryone,
  peopleDepartment,
  peopleLocation,
  profile,
  profileGroups,
  profileFollowing,
  profileFollowers,
];

export const ACTIVITY_TAB_ROUTES = [activity];

export const LEADERBOARD_TAB_ROUTES = [leaderboard, leaderboardView];

export const ADMIN_TAB_ROUTES = [
  adminAnalyticsOverview,
  adminAnalyticsGroups,
  adminAnalyticsUsers,
  adminAnalyticsPosts,
  adminAnalyticsShares,
  adminAnalyticsLeaderboards,
  adminPostManagement,
  adminUserManagement,
  adminPeople,
  adminPeopleInvite,
  adminGroups,
  adminInvitations,
  adminMessages,
  adminLeaderboards,
  adminContentEmails,
  adminContentEmailCreate,
  adminContentEmailEdit,
  adminSettings,
  adminSettingsAccount,
  adminSettingsLocations,
  adminSettingsDisclosures,
  adminSettingsPolicies,
  adminSettingsReferrals,
  adminSettingsCompanyOnboarding,
  adminSettingsCustomOnboarding,
  adminSettingsUserSegments,
  adminSettingsShareTracking,
  adminSettingsSharing,
  adminSettingsStickers,
  adminUpgrade,
  adminBilling,
  adminSettingsAssignments,
  adminSettingsAssignmentsCreate,
  adminSettingsAssignmentsEdit,
];

export const PROTECTED_ROUTES = [
  account,
  content,
  contentShare,
  contentComment,
  contentLike,
  notifications,
  onboardingProfile,
  onboardingFollows,
  onboardingCreate,
  onboardingIdentity,
  onboardingSocials,
  search,
  postCreate,
  postEdit,
  share,
  workspaces,
  setupProfile,
  setupWorkspace,
  ...ACTIVITY_TAB_ROUTES,
  ...ADMIN_TAB_ROUTES,
  ...DISCUSSIONS_TAB_ROUTES,
  ...GROUPS_TAB_ROUTES,
  ...HOME_TAB_ROUTES,
  ...LEADERBOARD_TAB_ROUTES,
  ...PEOPLE_TAB_ROUTES,
];
